import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { AppTheme } from '../../styles/AppTheme';
import { Badge } from '@material-ui/core';

export class CustomToggleButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggleButtonSelected: this.props.toggleButtonSelected || 0
    }
  }

  handleTableFilterChange(event, buttonSelected) {
    if (buttonSelected !== null) {
      this.setState({
        toggleButtonSelected: buttonSelected
      })
    }
  }

  render() {
    const {buttonData, fullWidth = false} = this.props
    if(!Array.isArray(buttonData) || buttonData.length === 0) {
      return null
    }
    return(<ToggleButtonGroup
      value={this.state.toggleButtonSelected}
      exclusive
      onChange={this.handleTableFilterChange.bind(this)}
      aria-label='text alignment'
      classes={{
        root: css(Styles.toggleButtonGroupRoot),
        grouped: css(Styles.toggleButtonGrouped),
      }}
      className={css(fullWidth ? [Styles.toggleGroup, Styles.toggleGroupFullWidth] : Styles.toggleGroup)}
    >
      {buttonData.map((data,index)=>{
        if(data.buttonText && data.onClick) {
          return(<ToggleButton
            value={index}
            aria-label='left aligned'
            onClick={data.onClick}
            disabled={this.state.toggleButtonSelected === index}
            disableRipple
            disableFocusRipple
            classes={{
              root: css(fullWidth ? [Styles.toggleButtonRoot,Styles.toggleButtonFullWidth ] : Styles.toggleButtonRoot),
              selected: css(Styles.toggleButtonSelected),
            }}
            className={css(Styles.toggleButton)}>
            {data.badgeContent ? (
              <Badge
                badgeContent={data.badgeContent}
                max={data.badgeMax || 100}
                color={data.badgeColor || 'primary'}
                classes={{ root: css(Styles.badgeRoot), badge: css(Styles.badgePosition, data.badgeTone === 'activeInt' && Styles.activeBadge) }}
              >
                <span className={css(Styles.toggleButtonText)}>{data.buttonText}</span>
              </Badge>
            ) : (
              <span className={css(Styles.toggleButtonText)}>{data.buttonText}</span>
            )}
          </ToggleButton>)
        }
      }).filter(a => !!a)}
    </ToggleButtonGroup>)
  }
}


const Styles = StyleSheet.create({
  toggleGroup: {
    width: '40%',
    display: 'flex',
    '@media (max-width: 1024px)': {
      width: '60%',
    },
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  toggleGroupFullWidth: {
    width: '100%',
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  toggleButtonGroupRoot: {
    width: '100%',
    borderRadius: 16,
  },

  toggleButtonGrouped: {
    borderRadius: 0,

    ':first-child': {
      borderTopLeftRadius: 16,
      borderBottomLeftRadius: 16,
    },

    ':last-child': {
      borderTopRightRadius: 16,
      borderBottomRightRadius: 16,
    },
  },
  toggleButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 15px',
  },
  toggleButtonRoot: {
    width: '100%',
    textTransform: 'none',
    color: '#666',
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  toggleButtonFullWidth: {
    flex: 1,
  },
  toggleButtonSelected: {
    color: AppTheme.primaryColor,
    borderBottom: `2px solid ${AppTheme.primaryColor}`,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },

  badgePosition: {
    position: 'relative',
    transform: 'none',
    top: 'auto',
    right: 'auto',
    marginLeft: '8px',
  },
  toggleButtonText: {
    fontWeight: 500,
    fontSize: 14,
    whiteSpace: 'nowrap',
    '@media (max-width: 1024px)': {
      fontSize: 12,
    },
  },
  badgeRoot: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badge: {
    position: 'relative',
    marginRight: '4px',
    display: 'inline-flex',
    order: -1,
  },
  activeBadge: {
    backgroundColor: '#00C473',
    color: '#ffffff',
  }
})

